// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"cbc7820e","411":"f31af9cc","618":"17274024","764":"ccb5f205","874":"57348f13"}[chunkId] + ".chunk.css";
};